module.exports = __webpack_public_path__ + "assets/img/travel-day32.9c85ee01.png";